'use client';

import React, {
  useState,
  type ReactNode,
} from 'react';
import styled from 'styled-components';

import Link from './Link';

export interface AccordionProps {
  title: string
  children: ReactNode
}

function Accordion({
  title,
  children,
}: AccordionProps) {
  const [open, setOpen] = useState(false);

  function toggle() {
    setOpen(!open);
  }

  return (
    <AccordionBase aria-expanded={open}>
      <Title
        as="button"
        onClick={() => toggle()}
      >
        <span>{title}</span>
        <i>chevron-down</i>
      </Title>
      <Panel>
        {children}
      </Panel>
    </AccordionBase>
  );
}

export const AccordionBase = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 0fr;

  transition: grid-template-rows 0.2s ease-in-out;
  color: var(--navbar-toggle-accent-color, #700);
  background: var(--navbar-toggle-accent-background, #FFF0F0);

  border-radius: 8px;

  &[aria-expanded="true"] {
    grid-template-rows: min-content 1fr;

    & > ${Link} > i {
      transform: rotate(180deg);
    }
  }

  & > ${Link} > i {
    font-size: 20px;
  
    transform: rotate(0deg);
    transition: transform 0.2s ease-in-out;
  }
`;

const Title = styled(Link).attrs({ as: 'button' })``;

export const Panel = styled.div`
  box-sizing: border-box;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: 12px;
  /* padding: 16px 24px 32px 24px; */

  & > ${Link} {
    margin: 0 24px;

    font-size: 14px;
    padding: 0;

    &:hover {
      text-decoration: underline;
      background-color: unset;
    }

    &:first-child {
      margin-top: 16px;
    }

    &:last-child {
      margin-bottom: 24px;
    }
  }
`;

export default Accordion;
